import { Col, Row, Breadcrumb } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import CategoriesList from "./categoriesList";
import { getCategoryApi } from "../../api/category";
import Title from "../UI/Title/Title";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { Search } from "../UI/Search/Search";
import { FilterInput } from "../UI/FilterApi/filterapi";
import { getPriceSchemeDropdown } from "../../api/pricescheme";

const Category = () => {
  const { t } = useTranslation("common");
  const [tableKey, setTableKey] = useState("");
  const navigate = useNavigate();
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedCategory, setPaginatedCategory] = useState<any>();
  const [, setInitialValues] = useState({ isActive: undefined });
  const [page, setPage] = useState<number>(1);

  const resetFilters = () => {
    getCategories({
      limit: page * 10 + 10,
      q: "",
    }).then((res) => {
      setPaginatedCategory(res.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getCategories({
      limit: page * 10 + 10,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedCategory(res.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getCategories({
      limit: page * 10 + 10,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedCategory(res.data);
    });
  };

  const getCategories = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await CategoryMutation(params);
  };
  const { mutateAsync: CategoryMutation, isLoading: isCategoryLoading } =
    useMutation("categories", getCategoryApi);

  const [formatedPriceScheme, setFormatedPriceScheme] = useState<{}[]>();
  const { isLoading: loadingPriceScheme } = useQuery(
    "PriceScheme",
    getPriceSchemeDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedPriceScheme(
          res.data
            .map((price: any) => {
              if (price.isActive) {
                return { value: price.id, label: price.name };
              } else {
                return null;
              }
            })
            .filter((price: any) => price !== null)
        );
        if (res.data.length > 0) {
          setInitialValues({ isActive: res.data[0].id });
        }
      },
    }
  );

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("inventory")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("categories-list")}
                  </span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("categories-list")}`} />
        </Col>
        <Col offset={1} span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
            onEnter={() => {
              handleSearch();
            }}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          offset={14}
          span={2}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton
            onClick={() => {
              navigate(`/category/create`, {
                state: {
                  formatedPriceScheme: formatedPriceScheme,
                  loadingPriceScheme: loadingPriceScheme,
                },
              });
            }}
          />
        </Col>
        <Col offset={1} span={22}>
          <CategoriesList
            CategoryMutation={CategoryMutation}
            isCategoryLoading={isCategoryLoading}
            search={search}
            paginatedCategory={paginatedCategory}
            setPaginatedCategory={setPaginatedCategory}
            page={page}
            setPage={setPage}
            filter={filter}
            tableKey={tableKey}
          />
        </Col>
      </Row>
    </>
  );
};

export default Category;
